<template>
  <div class="d-flex">
    <span class="text-md DARK-TEXT" selenium="job-details-received">
      {{ prefix | capitalize }} {{ new Date(time) | timeReceivedJobs }}
    </span>
    <transition name="FADE" mode="out-in">
      <span
          v-if="showNewMatch"
          v-tooltip="{
            content: 'New leads expire in 48 hours. Reply before it’s gone!',
            trigger: 'click hover',
          }"
          class="d-flex ai-center text-md c-depot">
        <span class="BULLET" selenium="job-details-time-response"/>
        <vk-icon name="simple-clock" class="ICON" />
        {{ formatTime }}
        till overdue
      </span>
      <span
          v-else-if="isNewMatch"
          class="d-flex ai-center text-md c-depot">
        <span class="BULLET" selenium="job-details-time-response"/>
        <vk-icon name="simple-clock" class="ICON" />
        Unresponsive {{ formatTime }}
      </span>
    </transition>
  </div>
</template>

<script>
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';

import { isBefore, differenceInHours, differenceInDays } from 'date-fns';

export default {
  name: 'time-received-with-status',
  mixins: [
    jobParams,
    job,
  ],
  computed: {
    showNewMatch () {
      return this.isNewMatch && isBefore(new Date(Date.now()), new Date(this.timeToExpire));
    },
    prefix () {
      return this.isFinishedMatch ? this.match.status : 'Received';
    },
    time () {
      return this.isFinishedMatch
        ? this.match.time_updated
        : this.match.time_created;
    },
    formatTime () {
      const diffInDays = Math.abs(differenceInDays(new Date(this.timeToExpire), new Date()));
      const diffInHours = Math.abs(differenceInHours(new Date(this.timeToExpire), new Date()));
      return diffInDays > 1
        ? `${diffInDays} days`
        : `${diffInHours} hour${diffInHours > 1 ? 's' : ''}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .BULLET {
    @include circle($unit/2);
    margin: 0 $unit;
    background-color: $color-gray60;
  }

  .ICON {
    @include h6;
    margin-right: $unit/2;
  }
  .DARK-TEXT {
    color: #808286;
  }
</style>
